import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "fullscreen-modal__top-title" }
const _hoisted_4 = { class: "fullscreen-modal__title" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6 offset-md-6" }
const _hoisted_8 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_9 = { class: "mt-md-2" }
const _hoisted_10 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_11 = {
  key: 0,
  class: "calendar-selection__default"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-warning" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = {
  key: 1,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarSelection = _resolveComponent("CalendarSelection")!
  const _component_BasePrice = _resolveComponent("BasePrice")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_PriceLegendActivities = _resolveComponent("PriceLegendActivities")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.configuration.choose-date')), 1),
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ]),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_CalendarSelection, {
                  label: "am",
                  ISODate: _ctx.selectedDateEnd
                }, null, 8, ["ISODate"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_BasePrice, {
                selectedDate: _ctx.selectedDateEnd,
                activityId: _ctx.activityId
              }, null, 8, ["selectedDate", "activityId"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Calendar, {
      onChangeDateStart: _ctx.onChangeDateStart,
      onChangeDateEnd: _ctx.onChangeDateEnd,
      selectedDateStart: _ctx.selectedDateStart,
      selectedDateEnd: _ctx.selectedDateEnd,
      ticketId: _ctx.activityId,
      isTimeList: _ctx.isTimeList,
      type: "activity"
    }, null, 8, ["onChangeDateStart", "onChangeDateEnd", "selectedDateStart", "selectedDateEnd", "ticketId", "isTimeList"]),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (!_ctx.selectedDateStart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.configuration.choose-date-in-calendar')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_CalendarSelection, {
                label: "am",
                ISODate: _ctx.selectedDateEnd
              }, null, 8, ["ISODate"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_BasePrice, {
            selectedDate: _ctx.selectedDateEnd,
            activityId: _ctx.activityId
          }, null, 8, ["selectedDate", "activityId"]),
          _createVNode(_component_PriceLegendActivities, { "activity-id": _ctx.activityId }, null, 8, ["activity-id"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}